import { render } from "./IconIntroChart.vue?vue&type=template&id=1dc72e8e"
const script = {}

import exportComponent from "F:\\PROMODUL\\Projets\\APP.RESPIRE\\code\\respire\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__